/* YYorrZ Theme JS — luxury rebuild */
(function(){
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Scroll reveal */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealEls.forEach(function(el){ el.classList.add('is-visible'); });
  } else {
    var revealObserver = new IntersectionObserver(function(entries, observer){
      entries.forEach(function(entry){
        if(entry.isIntersecting){ entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, {rootMargin:'0px 0px -7% 0px', threshold:0.08});
    revealEls.forEach(function(el){ revealObserver.observe(el); });
  }

  /* Header state */
  var header = document.querySelector('[data-site-header]');
  function syncHeader(){ if(header) header.classList.toggle('is-scrolled', window.scrollY > 12); }
  syncHeader();
  window.addEventListener('scroll', syncHeader, {passive:true});

  /* Mobile menu */
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var menuToggles = document.querySelectorAll('[data-menu-toggle]');
  function setMenu(open){
    if(!mobileNav) return;
    mobileNav.classList.toggle('is-open', open);
    document.body.classList.toggle('menu-open', open);
    menuToggles.forEach(function(btn){ btn.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  }
  menuToggles.forEach(function(btn){ btn.addEventListener('click', function(){ setMenu(!mobileNav.classList.contains('is-open')); }); });

  /* Search modal */
  var searchOpen = document.querySelector('[data-search-open]');
  var searchModal = document.querySelector('[data-search-modal]');
  function closeSearch(){ if(searchModal){ searchModal.classList.remove('is-open'); if(searchOpen) searchOpen.setAttribute('aria-expanded','false'); } }
  if(searchOpen && searchModal){
    searchOpen.addEventListener('click', function(){
      searchModal.classList.add('is-open');
      searchOpen.setAttribute('aria-expanded','true');
      var input = searchModal.querySelector('input[type="search"]');
      if(input) window.setTimeout(function(){ input.focus(); }, 80);
    });
    searchModal.addEventListener('click', function(e){ if(e.target === searchModal) closeSearch(); });
  }
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ setMenu(false); closeSearch(); } });

  /* Shop-the-look hotspots */
  document.querySelectorAll('[data-hotspot]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.stopPropagation();
      var id=this.getAttribute('data-hotspot');
      document.querySelectorAll('.hotspot-popover').forEach(function(p){ if(p.getAttribute('data-popover')!==id) p.classList.remove('is-open'); });
      var pop=document.querySelector('[data-popover="'+id+'"]'); if(pop) pop.classList.toggle('is-open');
    });
  });
  document.addEventListener('click', function(){ document.querySelectorAll('.hotspot-popover.is-open').forEach(function(p){p.classList.remove('is-open');}); });

  function formatMoney(cents){
    if(typeof cents==='string') cents=parseInt(cents,10);
    var currency=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'USD';
    return (cents/100).toLocaleString(undefined,{style:'currency',currency:currency});
  }

  /* Product variants */
  document.querySelectorAll('[data-variant-option]').forEach(function(option){
    option.addEventListener('change', function(){
      var form=this.closest('form')||this.closest('[data-product-form]'); if(!form) return;
      var selected={};
      form.querySelectorAll('[data-variant-option]').forEach(function(opt){ if(opt.type==='radio'&&opt.checked) selected[opt.name]=opt.value; if(opt.tagName==='SELECT') selected[opt.name]=opt.value; });
      var variants=window.productVariants||[];
      var match=variants.find(function(v){ return Object.keys(selected).every(function(k){ var idx=parseInt(k.replace('option',''),10)-1; return v.options[idx]===selected[k]; }); });
      if(match){
        var priceEl=document.querySelector('[data-product-price]'); if(priceEl) priceEl.textContent=formatMoney(match.price);
        var compareEl=document.querySelector('[data-product-compare]');
        if(compareEl){ if(match.compare_at_price>match.price){compareEl.style.display='';compareEl.textContent=formatMoney(match.compare_at_price);}else{compareEl.style.display='none';} }
        if(match.featured_image&&match.featured_image.src){ var mainImg=document.querySelector('[data-product-main-image]'); if(mainImg) mainImg.src=match.featured_image.src; }
        var idInput=form.querySelector('[name="id"]'); if(idInput) idInput.value=match.id;
        var atc=form.querySelector('[data-add-to-cart]'); if(atc){atc.disabled=!match.available;atc.textContent=match.available?(atc.getAttribute('data-add-text')||'ADD TO BAG'):'Sold Out';}
      }
    });
  });

  document.querySelectorAll('[data-color-swatch]').forEach(function(swatch){
    swatch.addEventListener('click',function(){ var group=this.closest('[data-option-group]'); if(!group)return; group.querySelectorAll('[data-color-swatch]').forEach(function(s){s.classList.remove('is-selected');}); this.classList.add('is-selected'); var input=this.querySelector('input'); if(input){input.checked=true;input.dispatchEvent(new Event('change',{bubbles:true}));} });
  });
  document.querySelectorAll('[data-size-btn]').forEach(function(btn){
    btn.addEventListener('click',function(){ var group=this.closest('[data-option-group]'); if(!group)return; group.querySelectorAll('[data-size-btn]').forEach(function(b){b.classList.remove('is-selected');}); this.classList.add('is-selected'); var input=this.querySelector('input'); if(input){input.checked=true;input.dispatchEvent(new Event('change',{bubbles:true}));} });
  });
  document.querySelectorAll('.product-thumb').forEach(function(btn){
    btn.addEventListener('click',function(){ document.querySelectorAll('.product-thumb').forEach(function(t){t.classList.remove('is-active');}); this.classList.add('is-active'); var main=document.querySelector('[data-product-main-image]'); if(main&&this.getAttribute('data-thumb-src')) main.src=this.getAttribute('data-thumb-src'); });
  });
})();
